/**
 * Logging utilities
 */
import log from 'loglevel';
import { isDevelopmentOrTest } from './environment_helper';

// Log level based on environment
if (isDevelopmentOrTest()) {
  log.setLevel('debug');
} else {
  log.setLevel('silent'); // No logs in production
}

export const logger = log;